// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";
import ticker from "./ticker";
import copyLink from "./copyLink";


// Call the menu and infinite scroll functions
menuOpen();
infiniteScroll();
ticker();
copyLink();
